/**
 * @file Role checks for UI (mirror server RBAC at a coarse level).
 */

/** True if the user has the admin role. */
export function isAdmin(roles?: string[] | null): boolean {
  return Boolean(roles?.includes("admin"));
}

/** Can create/edit chapters, pages, versions (author or admin). */
export function canManageContent(roles?: string[] | null): boolean {
  if (!roles?.length) {
    return false;
  }
  return roles.includes("admin") || roles.includes("author");
}

/** Can approve/reject approval requests (reviewer or admin). */
export function canReviewApprovals(roles?: string[] | null): boolean {
  if (!roles?.length) {
    return false;
  }
  return roles.includes("admin") || roles.includes("reviewer");
}
